<div id="wrapper">
<mat-card>
    <h1>Example use cases</h1>
    <div>
      <p class="description">
          Example use cases, that you can try out with this application, are:
      </p>
      <ul id="example-use-cases-list">
        <li>View and create assets using the <a [routerLink]="['/my-assets']">Assets</a> page</li>
        <li>View and create policies and apply these to assets in your Dataspace using the <a [routerLink]="['/policies']">Policies</a> page</li>
        <li>Publish a new asset into your Dataspace using the <a [routerLink]="['/contract-definitions']">Contract Definitions</a> page</li>
        <li>View the asset catalog available to you in your Dataspace using the <a [routerLink]="['/catalog-browser']" class="md-accent">Catalog Browser</a></li>
        <li>Negotiate a contract for data sharing in your Dataspace using the <a [routerLink]="['/catalog-browser']">Catalog Browser</a></li>
        <li>View your existing contracts in the <a [routerLink]="['/contracts']">Contracts</a> page</li>
        <li>Transfer an asset in your Dataspace using the <a [routerLink]="['/contracts']">Contracts</a> page</li>
        <li>View which assets have been transferred in your Dataspace in the <a [routerLink]="['/transfer-history']">Transfer History</a> page</li>
      </ul>
    </div>
</mat-card>
</div>
